import React from 'react';
import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadMaCisCreator,
  setMaCisPageCreator,
  setMaCisPerPageCreator,
  setMaCisSortCreator,
  setMaCisFiltersCreator,
  removeMaCisFiltersCreator,
  acceptUnknownImportsCreator,
  rejectUnknownImportsCreator,
} from 'store/actionsCreators';
import { setMaCisProfileCreator } from '../../../../store/actionsCreators';
import UnknownImports from '../../../../shared/Cis/UnknownImports/UnknownImports';

const mapStateToProps = ({ loading, ma, user }) => ({
  loading: isLoading(loading, 'LOAD_IMPORTER_UNKNOWN'),
  list: ma.cis.unknownImports,
  appType: user.appType,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCisCreator('unknownImports')),
  setPage: (payload) => dispatch(setMaCisPageCreator('unknownImports', payload)),
  setPerPage: (payload) => dispatch(setMaCisPerPageCreator('unknownImports', payload)),
  setSort: (payload) => dispatch(setMaCisSortCreator('unknownImports', payload)),
  setFilters: (payload) => dispatch(setMaCisFiltersCreator('unknownImports', payload)),
  removeFilters: () => dispatch(removeMaCisFiltersCreator('unknownImports')),
  acceptEntry: (payload) => dispatch(acceptUnknownImportsCreator(payload, 'ma')),
  rejectEntry: (payload) => dispatch(rejectUnknownImportsCreator(payload, 'ma')),
  setProfile: (payload) => dispatch(setMaCisProfileCreator('unknownImports', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnknownImports);
